/* eslint-disable no-lonely-if */

import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';

class FrontendAuth extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    const { routerConfig, location } = this.props;
    const { pathname } = location;
    const targetRouterConfig = routerConfig.find(
      (item) => item.path.toLowerCase() === pathname.toLowerCase()
    );
    const { meta, title } = targetRouterConfig
    if (title) document.title = title
    if (meta) {
      for (let key in meta) {
        let oMeta = document.createElement('meta');
        oMeta.name = key
        oMeta.content = meta[key]
        document.getElementsByTagName('head')[0].appendChild(oMeta);
      }
      // const metaName = 'window-custom'
      // let oMeta = document.createElement('meta');
      // oMeta.content = meta[metaName]
      // oMeta.name = metaName
      // document.getElementsByTagName('head')[0].appendChild(oMeta);
      // document.querySelector('meta[name="viewport"]').setAttribute(
      // const component = (
      //   <DocumentMeta {...meta}>
      //     <targetRouterConfig.component />
      //   </DocumentMeta>
      // )
      // console.log(component, targetRouterConfig.component)
      // return <Route path={pathname} component={component} />
    }
    return <Route path={pathname} component={targetRouterConfig.component} />
    // if (isLogin) {
    //   // 如果是登陆状态，想要跳转到登陆，重定向到主页
    //   if (pathname === '/login') {
    //     return <Redirect to="/" />;
    //   } else {
    //     // 如果路由合法，就跳转到相应的路由
    //     if (targetRouterConfig) {
    //       return (
    //         <Route path={pathname} component={targetRouterConfig.component} />
    //       );
    //     } else {
    //       // 如果路由不合法，重定向到 404 页面
    //       return <Redirect to="/404" />;
    //     }
    //   }
    // } else {
    //   // 非登陆状态下，当路由合法时且需要权限校验时，跳转到登陆页面，要求登陆
    //   if (targetRouterConfig && targetRouterConfig.auth) {
    //     return <Redirect to="/login" />;
    //   } else {
    //     // 非登陆状态下，路由不合法时，重定向至 404
    //     return <Redirect to="/404" />;
    //   }
    // }
  }
}

export default FrontendAuth;
